import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useDevAuth } from '../hooks/useAuth';

// Use dev auth in development, real auth in production
const useAppAuth = import.meta.env.DEV ? useDevAuth : useAuth;

interface LoginProps {
  error?: string | null;
}

export function Login({ error }: LoginProps) {
  const { isAuthenticated, login } = useAppAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-sand">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-serif font-bold text-brand-primary mb-2">
            Sales Leads
          </h1>
          <p className="text-font-secondary">
            Sign in to access the dashboard
          </p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-600 text-sm text-center">{error}</p>
          </div>
        )}

        <div className="flex justify-center">
          <button
            onClick={login}
            className="flex items-center justify-center gap-3 w-full max-w-xs px-6 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-bg transition-colors font-medium"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Sign in with WayFong
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-center text-font-secondary">
            Only @wayfong.com and @wallyco.net accounts are allowed.
          </p>
        </div>
      </div>
    </div>
  );
}
